import PropTypes from 'prop-types';
import React from 'react';
import Box from '../box/box.jsx';
import Modal from '../modal/modal.jsx';
import styles from './rb-upload-success-modal.css';

const RbUploadSuccessModal = props => (
    <Modal
        className={styles.modalContent}
        contentLabel={'Done uploading.'}
        onRequestClose={props.onCancel}
    >
        <Box className={styles.body}>
            <Box className={styles.flexWrapper}>
                <Box className={styles.editorWrapper}>
                    <h3 className={styles.title}>{'Congratulations!'}</h3>
                    <p className={styles.text}>{'Update success, connected.'}</p>
                </Box>
                <Box className={styles.buttonRow}>
                    <button
                        className={styles.okButton}
                        onClick={props.onCancel}
                    >
                        {'OK'}
                    </button>
                </Box>
            </Box>
        </Box>
    </Modal>
);

RbUploadSuccessModal.propTypes = {
    onCancel: PropTypes.func.isRequired
};

export default RbUploadSuccessModal;
